/**
 * UUIDv7 — identifiants générés CÔTÉ CLIENT (ADR-11).
 *
 * Deux raisons, toutes deux structurantes :
 *  1. Sans identifiant connu avant l'envoi, la création hors ligne est impossible :
 *     l'appareil doit pouvoir référencer une entité qu'il vient de créer.
 *  2. Le préfixe temporel rend les identifiants monotones, donc les insertions
 *     séquentielles dans les index B-tree — contrairement à UUIDv4, qui fragmente.
 *
 * Format (RFC 9562) : 48 bits d'horodatage ms | version 7 | 74 bits aléatoires.
 */
const HEX = Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
function randomBytes(length) {
    const bytes = new Uint8Array(length);
    globalThis.crypto.getRandomValues(bytes);
    return bytes;
}
export function uuidv7(now = Date.now()) {
    const bytes = randomBytes(16);
    // 48 bits d'horodatage, gros-boutiste
    const ts = BigInt(now);
    bytes[0] = Number((ts >> 40n) & 0xffn);
    bytes[1] = Number((ts >> 32n) & 0xffn);
    bytes[2] = Number((ts >> 24n) & 0xffn);
    bytes[3] = Number((ts >> 16n) & 0xffn);
    bytes[4] = Number((ts >> 8n) & 0xffn);
    bytes[5] = Number(ts & 0xffn);
    bytes[6] = (bytes[6] & 0x0f) | 0x70; // version 7
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
    const h = (i) => HEX[bytes[i]];
    return (h(0) + h(1) + h(2) + h(3) + '-' +
        h(4) + h(5) + '-' +
        h(6) + h(7) + '-' +
        h(8) + h(9) + '-' +
        h(10) + h(11) + h(12) + h(13) + h(14) + h(15));
}
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isUuid(value) {
    return UUID_RE.test(value);
}
export function isUuidV7(value) {
    return isUuid(value) && value[14] === '7';
}
/** Horodatage encodé dans un UUIDv7, utile au tri et au diagnostic. */
export function timestampOf(uuid) {
    if (!isUuidV7(uuid)) {
        throw new TypeError(`UUIDv7 attendu, reçu : ${uuid}`);
    }
    return Number(BigInt('0x' + uuid.slice(0, 8) + uuid.slice(9, 13)));
}
//# sourceMappingURL=uuidv7.js.map